import { AuthUtil } from 'src/app/data/utils/auth.utils';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../config/environments/environment';
import { AuthResponse } from '../models/interfaces/auth-response.interface';
import { RefreshTokenDto } from './../models/dto/refresh-token.dto';
import { SignInService } from './sign-in.service';
import { SignOutService } from './sign-out.service';
import { UserUtil } from '../utils/user.utils';
import { LoginResultDto } from '../models/dto/login-result.dto';

@Injectable()
export class AuthService {
  constructor(
    private http: HttpClient,
    private readonly signInService: SignInService,
    private readonly signOutService: SignOutService,
    private readonly authUtil: AuthUtil,
    private readonly userUtil: UserUtil
  ) { }

  isAuthenticated(): boolean {
    if (
      this.authUtil.getAccessToken() != null &&
      this.authUtil.getAccessToken() != ''
    ) {
      return true;
    }
    return false;
  }

  async login(email: string, password: string): Promise<LoginResultDto> {
    return await this.signInService.login(email, password);
  }

  async loginByPass(accessToken: string, refreshToken: string): Promise<LoginResultDto> {
    const decoded = this.authUtil.decodeJwt(accessToken);
    const authDto: AuthResponse = {
      access_token: accessToken,
      refreshToken: refreshToken,
      id: decoded.sub,
      email: decoded.email,
      identities: decoded.identities,
    };

    return await this.signInService.loginByPass(authDto);
  }

  async logout(): Promise<void> {
    await this.signOutService.logout();
  }

  forgotPassword(email: string): Observable<any> {
    const body = JSON.stringify({ email });

    return this.http.post(`${environment.api.baseUrl}/auth/forgot-password`, body, {
      responseType: 'text',
    });
  }

  confirmForgotPassword(email: string, confirmationCode: string, password: string): Observable<void> {
    const body = { email, confirmationCode, password }
    return this.http.post<void>(
      `${environment.api.baseUrl}/auth/confirm-forgot-password`, body
    );
  }

  updatePassword(email: string, newPassword: string): Observable<any> {
    const request = JSON.stringify({ email, newPassword });

    return this.http.patch(
      `${environment.api.baseUrl}/auth/v2/update-password`,
      request,
      { responseType: 'text' }
    );
  }

  refreshToken(): Observable<any> {
    const user = this.userUtil.getUser();
    const refreshtoken = this.authUtil.getRefreshToken();
    const dto: RefreshTokenDto = {
      email: user.email,
      refreshToken: refreshtoken,
    };

    return this.http.post<any>(
      `${environment.api.baseUrl}/auth/refreshtoken`,
      dto
    );
  }
}
